import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import * as fromSignin from '../../../store/reducers';
import { InviteActions } from '../../../store/actions';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss']
})
export class InviteComponent implements OnInit {

  inviteLoading$: Observable<boolean>;
  inviteSuccess$: Observable<boolean>;
  inviteError$: Observable<any>;

  mfaRequired$: Observable<boolean>;

  inviteTokenExpired$: Observable<boolean>;
  inviteTokenInvalid$: Observable<boolean>;

  invitationForm: FormGroup;
  passwordPattern = '^.{4,}$';
  decodedMessage: any;
  submitted = false;
  subscriptions: Subscription[] = [];
  
  constructor(private store$: Store<fromSignin.State>, private route: ActivatedRoute, private router: Router) {
    this.route.params
      .pipe(map(params => InviteActions.decodeMessage({ message: params.message }))).subscribe(action => {
        this.store$.dispatch(action);
      });

    this.store$.pipe(select(fromSignin.getInviteDecodedMessage)).subscribe(decodedMessage => {
      this.decodedMessage = decodedMessage;
    });
    this.inviteError$ = this.store$.pipe(select(fromSignin.getInviteErrorMessage));
    this.inviteLoading$ = this.store$.pipe(select(fromSignin.getInviteLoading));
    this.inviteSuccess$ = this.store$.pipe(select(fromSignin.getInviteSuccess));
    this.inviteTokenExpired$ = this.store$.pipe(select(fromSignin.getInviteTokenExpired));
    this.inviteTokenInvalid$ = this.store$.pipe(select(fromSignin.getInviteTokenInvalid));

    this.mfaRequired$ = this.store$.pipe(select(fromSignin.getMfaRequired));

    this.subscriptions.push(
      this.mfaRequired$.pipe(first(required => !!required)).subscribe(mfaRequired => {
        if (mfaRequired) {
          this.router.navigate(['/signin/mfa']);
        }
      })
    );
  }

  get f() { return this.invitationForm.controls; }

  ngOnInit(): void {
    this.invitationForm = new FormGroup({
      username: new FormControl({ value: this.decodedMessage.username, disabled: true }, [Validators.email, Validators.required]),
      password: new FormControl('', [Validators.required, Validators.pattern(this.passwordPattern)]),
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.invitationForm.invalid) {
      return;
    }

    this.store$.dispatch(InviteActions.acceptInvitation({ password: this.invitationForm.value.password }));
  }

  ngOnDestroy(): void {
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }
}
